import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function usePrepaidCardImages() {
    const { t } = useTranslation('prepaidCard');
    const { data, status } = useQuery(queries.prepaidCardImages.list());
    const { pop } = useFlow();
    const toast = useToast();
    const images = data?.categories;
    const isLoading = status === 'pending';
    const isBlank = !isLoading && (!images || images.length === 0);
    useEffect(() => {
        if (status === 'error') {
            pop();
            toast.error(t('images.error'));
        }
    }, [toast, status]);
    return { images, isLoading, isBlank };
}

export default usePrepaidCardImages;
